/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contributions_Legend_LessInputs */

const en_contributions_legend_less = /** @type {(inputs: Contributions_Legend_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Less`)
};

const ar_contributions_legend_less = /** @type {(inputs: Contributions_Legend_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أقل`)
};

const bn_contributions_legend_less = /** @type {(inputs: Contributions_Legend_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কম`)
};

const de_contributions_legend_less = /** @type {(inputs: Contributions_Legend_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weniger`)
};

const es_contributions_legend_less = /** @type {(inputs: Contributions_Legend_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos`)
};

const fr_contributions_legend_less = /** @type {(inputs: Contributions_Legend_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moins`)
};

const pt_contributions_legend_less = /** @type {(inputs: Contributions_Legend_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos`)
};

const zh_contributions_legend_less = /** @type {(inputs: Contributions_Legend_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较少`)
};

const tr_contributions_legend_less = /** @type {(inputs: Contributions_Legend_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az`)
};

const ru_contributions_legend_less = /** @type {(inputs: Contributions_Legend_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меньше`)
};

const pl_contributions_legend_less = /** @type {(inputs: Contributions_Legend_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mniej`)
};

/**
* | output |
* | --- |
* | "Less" |
*
* @param {Contributions_Legend_LessInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const contributions_legend_less = /** @type {((inputs?: Contributions_Legend_LessInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contributions_Legend_LessInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_contributions_legend_less(inputs)
	if (locale === "bn") return bn_contributions_legend_less(inputs)
	if (locale === "de") return de_contributions_legend_less(inputs)
	if (locale === "es") return es_contributions_legend_less(inputs)
	if (locale === "fr") return fr_contributions_legend_less(inputs)
	if (locale === "pt") return pt_contributions_legend_less(inputs)
	if (locale === "zh") return zh_contributions_legend_less(inputs)
	if (locale === "tr") return tr_contributions_legend_less(inputs)
	if (locale === "ru") return ru_contributions_legend_less(inputs)
	if (locale === "pl") return pl_contributions_legend_less(inputs)
	return en_contributions_legend_less(inputs)
});